import { ApiResponse, http } from '@config/api';
import axios from 'axios';
import Cookies from 'js-cookie';

export interface Language {
	name: string;
	name_ka: string;
	code: string;
	icon: string;
}

export interface TranslationResponse {
	translatedText: string;
	sourceLanguage: string;
	targetLanguage: string;
	cached: boolean;
}

export interface TranslatePayload {
	text: string;
	targetLanguage: string;
}

export async function getLanguages(): Promise<Language[]> {
	const response = await http.get<ApiResponse<Language[]>>('translate', 'languages');
	return response.data.data;
}

export async function translate(payload: TranslatePayload): Promise<TranslationResponse[]> {
	const baseUrl = process.env.REACT_APP_API_BASE_URL;
	const url = `${baseUrl}translate/v1`;
	const accessToken = Cookies.get('accessToken');

	const response = await axios.post<ApiResponse<TranslationResponse[]>>(url, payload, {
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${accessToken}`,
		},
	});
	return response.data.data;
}
